<!--<aside class="sidebar">
  <nav class="menu">
    <ul>
      <li *ngFor="let menu of menus"
          [routerLink]="[menu.routeLink]"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
          (click)="closeSidenav.emit()">

        <span class="material-icons">inbox</span>
        <span>{{ menu.screenName }}</span>
      </li>
    </ul>
  </nav>
</aside>-->
<aside class="sidebar">
  <nav class="menu" style="background-color: #c1dbb7;">
    <ul>
      <li *ngFor="let menu of menus"
          [routerLink]="[menu.routeLink]"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
          (click)="selectMenu(menu.screenName ?? '')">

        <span class="material-icons">{{ getIcon(menu.screenName) }}</span>
        <span>{{ menu.screenName }}</span>

      </li>
    </ul>
  </nav>
</aside>
